import { Stack, Step, StepLabel, Stepper } from "@mui/material";
import { useState } from "react";
import UserReg from "../UserReg";
import { useTranslation } from "react-i18next";
import ConfirmAndCancelButtons from "../../../../../components/buttons/ConfirmAndCancelButtons";
import TermsLoginAndLanguageFooter from "../TermsLoginAndLanguageFooter";

const steps = ["PersonalInfoStepper", "AccountInfoStepper"];

// Map fields to corresponding step indices
const fieldMappings = {
  0: ["firstName", "lastName", "phoneNumber"],
  1: ["clinic", "username", "email", "password", "confirmPassword"],
};

export default function PersonalStepper({ onCancel }) {
  const { t } = useTranslation();
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState({});
  const [stepErrors, setStepErrors] = useState({}); // Use state instead of ref

  const totalSteps = steps.length;
  const isLastStep = activeStep === totalSteps - 1;
  const completedSteps = Object.keys(completed).length;
  const allStepsCompleted = completedSteps === totalSteps;

  const handleNext = () => {
    const newActiveStep =
      isLastStep && !allStepsCompleted
        ? steps.findIndex((_, i) => !(i in completed))
        : activeStep + 1;

    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep((prev) => Math.max(prev - 1, 0));
  };

  const getPageErrors = (errors) => {
    const errorKeys = Object.keys(errors);
    const newErrors = {};

    Object.entries(fieldMappings).forEach(([step, fields]) => {
      newErrors[step] = fields.some((field) => errorKeys.includes(field));
    });

    setStepErrors((prev) =>
      JSON.stringify(prev) !== JSON.stringify(newErrors) ? newErrors : prev
    );
  };

  const isStepFailed = (stepIndex) => stepErrors[stepIndex] || false;

  return (
    <Stack>
      <Stepper nonLinear activeStep={activeStep} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel error={isStepFailed(index)}>{t(label)}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <Stack
        minHeight={"70vh"}
        mt={2}
        mb={1}
        display={"flex"}
        justifyContent={"start"}
        height={"100%"}
      >
        <UserReg activeStep={activeStep} getPageErrors={getPageErrors} />
      </Stack>
      <ConfirmAndCancelButtons
        isStepper={true}
        cancelTitle="Cancel"
        backTitle="Back"
        nextTitle="Next"
        enableConfirmButton={false}
        backButtonProps={{
          disabled: activeStep === 0,
        }}
        nextButtonProps={{
          disabled: isLastStep,
        }}
        onCancel={onCancel}
        onBack={handleBack}
        onNext={handleNext}
        testId="auth.signup.stepper"
      />
      <TermsLoginAndLanguageFooter />
    </Stack>
  );
}
